import { defineComponent as _defineComponent } from 'vue';
import FormElement from "@/components/Form/FormElement.vue";
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FormConditional',
    props: {
        step: null
    },
    emits: ["onUpdateStep"],
    setup(__props, { emit }) {
        const props = __props;
        const conditionalDefined = computed(() => {
            return Boolean(props.step.when);
        });
        function onSkipBoolean(value) {
            if (props.step.when && value === false) {
                emit("onUpdateStep", Object.assign(Object.assign({}, props.step), { when: undefined }));
            }
            else if (value === true && !props.step.when) {
                const when = "$(inputs.when)";
                const newStep = Object.assign(Object.assign({}, props.step), { when, input_connections: Object.assign(Object.assign({}, props.step.input_connections), { when: undefined }) });
                emit("onUpdateStep", newStep);
            }
        }
        return { __sfc: true, emit, props, conditionalDefined, onSkipBoolean, FormElement };
    }
});
